import React from 'react';
import { AuthenticateWithRedirectCallback } from '@clerk/clerk-react';
import { Loader2 } from 'lucide-react';

export const SSOCallback: React.FC = () => {
  return (
    <div className="min-h-screen bg-[#09090B] text-[#FAFAFA] flex flex-col items-center justify-center p-6">
      <div className="flex flex-col items-center gap-4 text-center max-w-sm">
        <div className="w-12 h-12 rounded-2xl bg-linear-to-tr from-indigo-600 to-violet-500 flex items-center justify-center font-black text-white text-lg shadow-lg shadow-indigo-500/25">
          C
        </div>

        <div className="flex items-center gap-2 text-indigo-400">
          <Loader2 className="w-5 h-5 animate-spin" />
          <span className="text-sm font-semibold tracking-tight">Authenticating with Conversora...</span>
        </div>

        <p className="text-xs text-zinc-500">
          Completing secure single sign-on handshake. You will be redirected shortly.
        </p>

        {/* Clerk internal redirect completion engine */}
        <div className="hidden">
          <AuthenticateWithRedirectCallback
            signInForceRedirectUrl="/"
            signUpForceRedirectUrl="/"
            continueSignUpUrl="/sign-up"
          />
        </div>
      </div>
    </div>
  );
};

export default SSOCallback;
